import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { IdParam } from '../../models/gen/idParam';
import { MatterSummaryGetResult } from '../../models/gen/matterSummaryGetResult';
import { useGenericQuery } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const MATTER_CONTEXT_NAMES = {
  GET_MATTER_SUMMARY: 'getMatterSummary',
} as const;

const apis = apiGenerator();

/**
 * GET `/matter/{id}/summary`
 *
 * @param param -
 * @returns
 */
export const useGetMatterSummary = (param: IdParam) =>
  useGenericQuery(
    [MATTER_CONTEXT_NAMES.GET_MATTER_SUMMARY, param as Record<string, unknown>],
    async (_param) =>
      apis.get<void, MatterSummaryGetResult>(
        `${env.BASE_API_ENDPOINT}/matter/${param.id}/summary`,
        { ...queryOptions }
      ),
    { enabled: !!param.id }
  );
